import WebClientSocket from './WebClientSocket';

export default (() => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const options: { address: string } = ClientLoaderFilterComponentsPluginClientOptions;

        return new WebClientSocket(options);
    } catch (e) {
        return null;
    }
})();
